<template>
  <div></div>
</template>

<script>
import {verificaStep} from "@/lib/verificaStep";

export default {
  name: "DefaultRedirect",
  mounted() {
    this.$router.push('/customers/it/flightsub/');
  },
}
</script>

<style scoped>

</style>